import {
  defineNuxtPlugin,
  useRuntimeConfig,
} from '#imports'

export default defineNuxtPlugin(async () => {
  const config = useRuntimeConfig()

  if (config.public.MSW_ENABLED) {
    const { createWorker } = await import('../mocks/browser')
    const worker = createWorker(config.public.baseAPI)

    await worker.start({
      onUnhandledRequest(request, print) {
        if (!request.url.includes(config.public.baseAPI)) {
          return
        }

        print.warning()
      },
    })
  }
})
